import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-datos',
  templateUrl: './datos.component.html',
  styleUrls: ['./datos.component.scss']
})
export class DatosComponent implements OnInit {
  environment = environment.BASE_URL;
  data;
  respuestaGetPerfil:any;
  perfil;
  formulario;
  clienteid;
  respuestaUpdate;

  constructor(private _getPerfil:ClientesService, private _updateProfile:ClientesService, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getProfile();
    this.formulario = {
      imagen: '',
    }
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }
  
  getProfile(){
    // this.data = {
    //   'usuario':cliente
    // }
    // this._getPerfil.getPerfil(this.data).subscribe(
    this._getPerfil.getProfile().subscribe(
      data => {
        this.respuestaGetPerfil = data;
        if(this.respuestaGetPerfil.success){
          this.perfil = this.respuestaGetPerfil.content;
          this.clienteid = this.perfil.id;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  updateProfile(){
    const formData = new FormData();
    formData.append('usuario', this.clienteid);

    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._updateProfile.updateProfile(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.getProfile();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
}
